// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wc_a bhk_b bhk_wb"};